import { createSafeContext } from './utils';

type GoogleAnalyticsContext = {
  gaOnclick: () => void;
};
// This is a quick way to allow Analytics tool to be passed down and consumed. This is highly specific to the boosted offers but
// If there was a need, would be exandable. -> I'm not expanding it because this may not even be the anlytics tool we use moving forward.
export const [GoogleAnalyticsProvider, useGoogleAnalytics] =
  createSafeContext<GoogleAnalyticsContext>(
    'GoogleAnalyticsProvider component was not found in tree'
  );
